import { defineMessages } from 'react-intl';

export const labelMessages = defineMessages({
  external: {
    defaultMessage: 'Send {count, plural, one {Shipment} other {Shipments}}',
    id: '8PSsWh',
    description: 'Send Shipment button label',
  },
  localCreate: {
    defaultMessage: 'Schedule {count, plural, one {Pickup} other {Pickups}}',
    id: 'RWhlL8',
    description: 'Schedule Pickup button label',
  },
  localCreateAndPrint: {
    defaultMessage: 'Schedule + Print {count, plural, one {Label} other {Labels}}',
    id: 'pkuclu',
    description: 'Schedule + Print Label button label',
  },
  multipleCreate: {
    defaultMessage: 'Process Shipments',
    id: 'zrQ3Ay',
    description: 'Process Shipments button label',
  },
  multipleCreateAndPrint: {
    defaultMessage: 'Process + Print Shipments',
    id: 's3gKu+',
    description: 'Process + Print Shipments button label',
  },
  standardCreate: {
    defaultMessage: 'Create {count, plural, one {Label} other {Labels}}',
    id: 'dZvTAt',
    description: 'Create Label button label',
  },
  standardCreateAndPrint: {
    defaultMessage: 'Create + Print {count, plural, one {Label} other {Labels}}',
    id: 'WK0tUE',
    description: 'Create + Print Label button label',
  },
  createLabelDisabledMessage: {
    defaultMessage: 'One of your selected orders is a demo order. Please unselect this order.',
    id: '4BiUWh',
    description: 'Disabled message for create label button',
  },
});
